import React from 'react';
import t from 'prop-types';
import "./Row.scss";

class Row extends React.Component {
  static propTypes = {
    flip: t.bool,
    align: t.string,
    className: t.string,    
    children: t.oneOfType([t.element, t.array]),
  };

  render() {
    const { flip, align, className, ...props } = this.props;
    let _className = className ? `${className} row` : 'row';
    /* eslint-disable */
    align === 'center' ? _className += ` row-align-center` : _className;
    align === 'bottom' ? _className += ` row-align-bottom` : _className;
    flip === true ? _className += ` row-flip` : _className;
    /* eslint-enable */
    
    return (
      <div {...props} className={_className}>
        {this.props.children}       
      </div>
    );
  }
}

export default Row;
